<dx-drawer class="searchPanel" openedStateMode="shrink"
           position="top"
           revealMode="expand"
           [(opened)]="isOpen"
           template="template"
           [animationEnabled]="false"
           (onOptionChanged)="handlePropertyChange($event)">
    <div *dxTemplate="let data of 'template'">
        <form (submit)="searchAndCloseClicked.emit()">
            <div class="search-container">
                <template [ngTemplateOutlet]="template">
                </template>
            </div>
            <div class="search-buttons">
              <span *ngIf="searchButtonsTemplate != null">
                <template [ngTemplateOutlet]="searchButtonsTemplate">
                </template>
              </span>
              <span *ngIf="searchButtonsTemplate == null">
                <dx-button *ngIf="!hasOnlySearchAndCloseButton" icon="search" [text]="languageService.LNG('Label.Search')" (onClick)="searchClicked.emit()"></dx-button>
                <dx-button [useSubmitBehavior]="true" icon="search" [text]="!hasOnlySearchAndCloseButton ? languageService.LNG('Label.SearchAndClose') : languageService.LNG('Label.Search')"></dx-button>
                <dx-button icon="close" [text]="languageService.LNG('Label.Clear')" (onClick)="resetClicked.emit()"></dx-button>
                <dx-button [text]="languageService.LNG('Label.Close')" (onClick)="closeClicked.emit()"></dx-button>
              </span>
            </div>
        </form>
    </div>
</dx-drawer>
